// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconUsdm } from "../../../icons/mono/build/icon-usdm.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const UsdmIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconUsdm.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  UsdmIcon.displayName = 'UsdmIcon';
}

export default UsdmIcon;